module.exports = __webpack_public_path__ + "media/assets/_twitter.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/_twitter.svg
// module id = 25
// module chunks = 0